import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AdminPage from './adminPages/Admin/Admin.page';
import ChatPage from './pages/Chat/Chat.page';
import Signin from './pages/User/SignIn/SignIn.page';
import Signup from './pages/User/SignUp/SignUp.page';
import PrivateRoute from './helpers/protectedRoutes';
import UploadPage from './adminPages/Upload/Upload.page';
import HomePage from './pages/Home/Home';
import ChatHistorySearch from './ui/components/chatHistorySearch/chatHistorySearch';
// import Test from './pages/Test/Test.page';
import TranscriptsPage from './adminPages/Transcripts/Transcripts.page';
import BulkUploadPage from './adminPages/BulkUpload/BulkUpload.page';
import Test from './pages/Test/Test.page';
import AddNewEntityPage from './adminPages/AddNewEntity/AddNewEntity.page';
import AddNewPackagePage from './adminPages/AddNewPackage/AddNewPackage.page';
import Dashboard from './pages/Dashboard/Dashboard';
import CaseDocumentUploadPage from './adminPages/CaseDocumentUpload/CaseDocumentUpload.page';
import TempAbstractUploadPage from './adminPages/TempAbstractUpload/TempAbstractUpload.page';
import Citations from './pages/Citation/CitationPage';
import PatientDetailPage from './pages/PatientDetail/PatientDetail';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import CICPLetterPage from './pages/CICPLetter/CICPLetter.page';
import CombinedReportPage from './pages/CombinedReport/CombinedReport.page';
import QuestionFormPage from './pages/QuestionForm/QuestionForm.page';
import ComingSoon from './pages/ComingSoon/ComingSoon';

//TODO move ChatHistorySearch from being a route to being part of the side bar expansion

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Router>
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* 
      <Route path="/chat" element={<ChatPage />} />
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            {' '}
            <AdminPage />{' '}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/upload"
        element={
          <PrivateRoute>
            {' '}
            <UploadPage />{' '}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/transcripts"
        element={
          <PrivateRoute>
            {' '}
            <TranscriptsPage />{' '}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/upload/bulk"
        element={
          <PrivateRoute>
            {' '}
            <BulkUploadPage />{' '}
          </PrivateRoute>
        }
      /> */}
      {/* TODO THESE 2 ARE TEMPORARY, need to be replaced later */}
      {/* <Route
        path="/admin/entity/add"
        element={
          <PrivateRoute>
            {' '}
            <AddNewEntityPage />{' '}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/package/add"
        element={
          <PrivateRoute>
            <AddNewPackagePage />
          </PrivateRoute>
        }
      /> */}
      <Route path="/signin" element={<Signin />} />
      {/* <Route path="/signup" element={<Signup />} /> */}
      {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
      {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
      {/* <Route path="/change-password" element={<ChangePassword />} /> */}
      <Route path="/chat/history/search" element={<ChatHistorySearch />} />
      {/* TODO Make sure to comment out test whenever pushing to live, or delete it, however */}
      {/* <Route path="/test" element={<Test />} /> */}
      <Route
        path="/questions/:userId"
        element={
          <PrivateRoute>
            <QuestionFormPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/cicp-letter/:userId"
        element={
          <PrivateRoute>
            <CICPLetterPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/combined-report/:userId"
        element={
          <PrivateRoute>
            <CombinedReportPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      {/* // TODO: Need to add better route names */}
      <Route
        path="/admin-dashboard"
        element={
          <PrivateRoute>
            <AdminDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/patient/:id"
        element={
          <PrivateRoute>
            <PatientDetailPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/citation/:userId"
        element={
          <PrivateRoute>
            <Citations />
          </PrivateRoute>
        }
      />
      <Route
        path="/lawyers"
        element={
          <PrivateRoute>
            <ComingSoon />
          </PrivateRoute>
        }
      />
      <Route
        path="/patients"
        element={
          <PrivateRoute>
            <ComingSoon />
          </PrivateRoute>
        }
      />
      <Route
        path="/physicians"
        element={
          <PrivateRoute>
            <ComingSoon />
          </PrivateRoute>
        }
      />
      {/* <Route
        path="/case/upload/:entityId"
        element={<CaseDocumentUploadPage />}
      />
      {/* TODO this is purely put as a placeholder so we have a quick solution to upload studies with*/}
      <Route path="/temp" element={<TempAbstractUploadPage />} />{' '}
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
